import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#parking-clip0_2249_1804)\" clip-rule=\"evenodd\"><path d=\"M12.682 7H9v9.912h2.184v-3.864h1.596q.784 0 1.456-.14a3.2 3.2 0 0 0 1.162-.504q.49-.35.77-.938t.28-1.456q0-.882-.308-1.456a2.3 2.3 0 0 0-.812-.924 3.2 3.2 0 0 0-1.19-.49A7.3 7.3 0 0 0 12.682 7m-.042 4.2h-1.456V8.848h1.12q.308 0 .644.042.336.028.602.154.28.126.448.364.182.224.182.602 0 .35-.14.588-.126.224-.35.364-.21.126-.49.182a2.7 2.7 0 0 1-.56.056\"></path><path d=\"M0 5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5zm5-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3\"></path></g><defs><clipPath id=\"parking-clip0_2249_1804\"><path fill=\"currentColor\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }